let backendUrl, publicKey;
backendUrl = "https://vikonews.herokuapp.com";
export { backendUrl, publicKey };
